import React from 'react';

const TricolorSVG = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    {/* línea superior */}
    <rect
      x="3"
      y="4"
      width="18"
      height="4"
      rx="2"
      fill="#d32f2f"   /* rojo */
    />

    {/* línea central */}
    <rect
      x="3"
      y="10"
      width="18"
      height="4"
      rx="2"
      fill="#fbc02d"   /* amarillo */
    />

    {/* línea inferior */}
    <rect
      x="3"
      y="16"
      width="18"
      height="4"
      rx="2"
      fill="#1976d2"   /* azul */
    />
  </svg>
);

export default TricolorSVG;
